import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateScheduledShowDocument } from './update.generated';

export const useUpdateScheduledShow = (
  options: ApiOptions<typeof UpdateScheduledShowDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(UpdateScheduledShowDocument, {
    ...useNotifications(UpdateScheduledShowDocument, {
      failure: t('api.common.error_generic'),
      success: (_data) => t('api.scheduled_show.update_success'),
    }),

    ...options,
  });
};
